<template>
  <header-secondary :enable-banner="true"></header-secondary>
  <div class="background-img flex items-center justify-between">
    <div class="size-box shadow rounded-lg bg-white">
      <div class="flex h-full flex-col justify-center">
        <p class="mb-10 text-4xl font-medium">Log in with your email.</p>
        <div class="flex flex-col">
          <label class="mb-1 ml-1 text-xs font-bold">EMAIL</label>
          <input
            v-model="email"
            tabindex="1"
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email address"
            class="btn mb-4 mr-4 rounded-lg bg-gray-100 p-4 focus:bg-white"
            @change="verifyEmail($event.target.value)"
            @keyup.enter="validateKeyEnter()"
            value
          />
          <!-- <template v-if="isWatchdogActiveOnDomain"> -->
          <checkbox
            :item="'I agree to the Terms of Use and Privacy Policy'"
            :handleSelect="handleCheckboxValue"
            :activeVal="false"
          />
          <!-- </template> -->
          <div>
            <button-main
              tabindex="3"
              class="outline-none mt-4 h-14 w-full"
              :class="{
                'cursor-pointer focus-within:ring-2 focus-within:ring-yellow-500 focus-within:ring-offset-1':
                  valid,
              }"
              size="xs"
              variant="yellow"
              :disabled="!valid"
              @click="requestCode()"
            >
              Continue
            </button-main>
          </div>
        </div>
        <!-- <div class="mt-3" v-if="!isWatchdogActiveOnDomain">
          <p class="text-xs text-body-color">
            By using this product, you agree to our <a class="text-body-color underline" :href="`https://${siteDomain}/terms-of-service`">Terms & Conditions</a> and <a class="text-body-color underline" :href="`https://${siteDomain}/privacy-policy`">Privacy Policy</a>.
          </p>
        </div> -->
        <!-- <div v-if="!isWatchdogActiveOnDomain" class="flex flex-col items-center justify-center mt-4">
          <p class="text-gray-400 mb-3">or</p>
          <a :href="`https://${siteDomain}/book-a-demo`" target="_blank">
            <p class="text-yellow-500">Book a demo</p>
          </a >
        </div> -->
      </div>
    </div>
  </div>
  <footer-main></footer-main>
</template>

<script>
import FooterMain from '@/components/FooterMain.vue';
import HeaderSecondary from '@/components/HeaderSecondary.vue';
import { toastResponse } from '@/common/handleServerResponse';
import ButtonMain from '@/components/Button.vue';
import Watchdog from '@/mixins/Watchdog';
import Checkbox from '@/components/CheckboxLogin.vue';

export default {
  components: {
    HeaderSecondary,
    FooterMain,
    ButtonMain,
    Checkbox,
  },
  mixins: [Watchdog],
  created() {
    const preloadedEmail = this.$route.query.email;
    if (preloadedEmail?.length !== 0) {
      this.email = preloadedEmail;
    }
  },
  data() {
    return {
      email: '',
      valid: false,
      checkboxValue: false,
    };
  },
  mounted() {
    const isValidMemberQueried =
      this.$router.currentRoute.value?.query?.valid_member;

    if (isValidMemberQueried === false) {
      this.showToast(
        "Sorry, we don't recognize this email. Please visit tianet.org to become a TIA member."
      );
      this.clearQuery();
    }
  },
  computed: {
    siteDomain() {
      if (process.env.SITE_DOMAIN === undefined) {
        return '';
      }
      return process.env.SITE_DOMAIN;
    },
  },
  methods: {
    validateKeyEnter() {
      if (this.valid) {
        this.requestCode();
      }
    },
    handleCheckboxValue(bool) {
      this.checkboxValue = bool;
    },
    showToast(message) {
      this.$toast.open({
        message: message,
        position: 'top-right',
        duration: 5000,
      });
    },

    clearQuery() {
      this.$router.replace({ query: null });
    },
    verifyEmail(email) {
      this.email = email;
      const emailValidator = /\S+@\S+\.\S+/;
      let plusSign = true;
      if (
        window.location.origin === 'https://highway.com' ||
        window.location.origin === 'https://gohighway.com'
      ) {
        if (email?.includes('+')) {
          plusSign = false;
        }
      }
      const isValid = emailValidator.test(email);

      // if (this.isWatchdogActiveOnDomain) {
      //   this.valid = isValid && plusSign && this.checkboxValue;
      // } else {
      //   this.valid = isValid && plusSign;
      // }
      this.valid = isValid && plusSign && this.checkboxValue;
    },
    async requestCode() {
      const res = await this.$store.dispatch('users/postSignIn', {
        email_address: this.email,
        site: this.getSiteDomain(),
      });

      switch (res?.status) {
        case 201:
          this.$router.push({
            name: 'LoginVerification',
            query: { email: this.email },
          });
          break;
        case 429:
          this.handleDomainRegistered(res);
          break;
        case 409:
          window.location.href = `/identity/saml/init?email=${this.email}&redirect_url=${process.env.API_URL}${process.env.BASE_URL}`;
          break;
        case 422:
          this.handleUnrecognizedEmail(res);
          break;
        default:
          toastResponse(this, res, null);
      }
    },
    getSiteDomain() {
      return this.isWatchdogActiveOnDomain
        ? 'tiawatchdog.com'
        : process.env.SITE_DOMAIN;
    },

    handleDomainRegistered(res) {
      if (this.isWatchdogActiveOnDomain) {
        this.showToast(
          'Please contact your company’s TIA administrator to request an invitation.'
        );
      } else {
        toastResponse(this, res, null);
        this.$router.push({ name: 'SignUp', query: { email: this.email } });
      }
    },

    handleUnrecognizedEmail(res) {
      if (this.isWatchdogActiveOnDomain) {
        this.showToast(
          'Sorry, we don’t recognize this email. Please visit tianet.org to become a TIA member.'
        );
      } else {
        toastResponse(this, res, null);
      }
    },
  },
  watch: {
    email: function (newVal) {
      this.verifyEmail(newVal);
    },
    checkboxValue: function (newVal) {
      console.log(newVal);
      this.verifyEmail(this.email);
    },
  },
};
</script>

<style>
.background-img {
  background-image: url('@/assets/Background-lines.png');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;
  height: calc(100vh - 100px);
  min-height: 530px;
  display: flex;
  padding-top: 30px;
  justify-content: center;
}
.border-gray {
  outline: none;
}

.shadow {
  box-shadow: 0px 4px 8px rgba(109, 113, 129, 0.05);
}
.size-box {
  width: 600px;
  height: 499px;
  padding: 60px;
  border: 1px solid rgba(237, 237, 240, 1);
}
.btn {
  width: 100%;
}

input {
  outline-color: #6d7181;
}
</style>
